document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var panel = document.querySelector('[data-mobile-menu]');

  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('is-open');
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  window.addEventListener('message', function (event) {
    if (typeof event.origin !== 'string' || !event.origin.includes('futureblink.com')) {
      return;
    }

    console.log('Hoppy iframe message:', event.data);

    if (!event.data || typeof event.data !== 'object') {
      return;
    }

    if (event.data.type === 'booking-successful') {
      try {
        sessionStorage.setItem('hoppyBookingData', JSON.stringify(event.data));
        console.log('Saved Hoppy booking data to sessionStorage');
      } catch (error) {
        console.error('Failed to save Hoppy booking data:', error);
      }
    }

    if (event.data.type === 'booking-customer-details') {
      try {
        sessionStorage.setItem('hoppyCustomerDetails', JSON.stringify(event.data));
        console.log('Saved Hoppy customer details to sessionStorage');
      } catch (error) {
        console.error('Failed to save Hoppy customer details:', error);
      }
    }
  });
});